module.exports = __webpack_public_path__ + "img/国轩科技.36e8d86f.png";